<div *ngIf="alert === 'OK'" class="alert alert-success alert-pgs" role="alert">
  {{alertMessage}}
</div>
<div *ngIf="alert === 'KO'" class="alert alert-danger alert-pgs" role="alert">
  {{alertMessage}}
</div>
<div class="body col-md-12">

  <div class="card card-container">
    <button (click)="loginOAuth2()" class="btn btn-primary btn-block">
      USE TRANSCITY SSO
    </button>
  </div>
</div>
